import { Component, Input, AfterViewInit, ViewChildren, QueryList, ElementRef, Renderer2, OnInit } from '@angular/core';
import { FormGroup, FormArray, Validators, NonNullableFormBuilder } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  TimeAndShiftsFormInterface,
  ShiftType,
  INITIAL_TIME_SHIFTS_VALUE,
  BaseShiftIcons,
  BaseStaffRequestFormInterface,
  EditInquiryFormInterface,
} from 'base';

@Component({
  selector: 'base-customer-edit-shift-view-modal',
  templateUrl: './base-customer-edit-shift-times-modal.component.html',
})
export class BaseCustomerEditShiftTimesModalComponent implements AfterViewInit, OnInit {
  @ViewChildren('startTimeInput') startTimeInputs: QueryList<ElementRef>;

  @Input({ required: true }) parentForm: FormGroup<BaseStaffRequestFormInterface> | FormGroup<EditInquiryFormInterface>;
  @Input({ required: true }) modalRef: NgbModalRef;
  @Input() activeShiftType: ShiftType;

  form = new FormGroup({
    timeShiftsForm: this.fb.array(
      INITIAL_TIME_SHIFTS_VALUE.map((shift) =>
        this.fb.group({
          type: this.fb.control(shift.type),
          startTime: this.fb.control(shift.startTime, Validators.required),
          endTime: this.fb.control(shift.endTime, Validators.required),
          break: this.fb.control(shift.break),
        })
      )
    ),
  });
  baseShiftIconsEnum = BaseShiftIcons;
  validated = false;

  constructor(private fb: NonNullableFormBuilder, private renderer: Renderer2) {}

  get timeShiftsForm(): FormArray<FormGroup<TimeAndShiftsFormInterface>> {
    return this.form.controls.timeShiftsForm as FormArray<FormGroup<TimeAndShiftsFormInterface>>;
  }

  ngOnInit() {
    this.updateForm();
  }

  ngAfterViewInit(): void {
    this.setAutofocus();
  }

  setAutofocus(): void {
    this.timeShiftsForm.controls.forEach((shift, index) => {
      const inputElement = this.startTimeInputs.toArray()[index];

      if (shift.value.type === this.activeShiftType) {
        this.renderer.selectRootElement(inputElement.nativeElement).focus();
      }
    });
  }

  closeModal() {
    this.modalRef.dismiss();
  }

  saveTimeShifts() {
    this.validated = true;

    if (this.timeShiftsForm.valid) {
      this.modalRef.close(this.timeShiftsForm.getRawValue());
      this.parentForm.controls.timeShiftsForm.setValue(this.timeShiftsForm.getRawValue());
    }
  }

  private updateForm() {
    this.timeShiftsForm.setValue(this.parentForm.controls.timeShiftsForm.getRawValue());
  }
}
